
define(
	'Tavano.TT_ExcludeFeeItemsFromSite.ExcludeFeeItem'
	, [
		'Facets.Translator',
		'Session',
		'underscore',
		"ItemRelations.Correlated.Collection"
	]
	, function (
		FacetsTranslator,
		Session,
		_,
		ItemRelationsCorrelatedCollection

	) {
		'use strict';

		_.extend(FacetsTranslator.prototype, {
			getApiParams: _.wrap(FacetsTranslator.prototype.getApiParams, function (fn) {
				var ret = fn.apply(this, _.toArray(arguments).slice(1));
				var facetExclude = ret['facet.exclude'];
				var exclude;
				if (facetExclude) {
					exclude = facetExclude.split(',');
					exclude.push('custitem_tt_exclude_fee_item_site');
				} else {
					exclude = ['custitem_tt_exclude_fee_item_site'];
				}
				ret['facet.exclude'] = exclude.join(',');
				return ret
			})
		});

		Session.getSearchApiParams = _.wrap(Session.getSearchApiParams, function (fn) {
			var ret = fn.apply(this, _.toArray(arguments).slice(1));
			ret['custitem_tt_exclude_fee_item_site'] = false;
			return ret;
		});

		_.extend(ItemRelationsCorrelatedCollection.prototype, {
			parse: function (response) {
				var original_items = _.compact(response.items) || [];
				var self = this;
				var items = {};
				_.each(_.pluck(original_items, 'correlateditems_detail'), function (correlated_items) {
					_.each(correlated_items, function (correlated_item) {
						if (
							self &&
							self.itemsIds &&
							correlated_item &&
							items &&
							!_.contains(self.itemsIds, correlated_item.internalid) &&
							!items[correlated_item.internalid]
						) {
							items[correlated_item.internalid] = correlated_item;
						}
					});
				});

				var items = _.reject(items, function (obj) {
					return obj.custitem_tt_exclude_fee_item_site === true;
				});

				return _.toArray(items);
			}
		});
	})
